import * as React from 'react';

import { UserProvider, UserContext } from 'modules/User'
import Router from './Router'
import "styles/app-component.less";
import "styles/app-component-mune.less";
import "styles/app-component-dialog.less";
import "styles/app-theme.less";
import "styles/app-layout.less";
import "styles/app-component-form.less";
// import "styles/app-component-table.less";
import "styles/app-component-tree.less";

class App extends React.Component {
	public render() {
		return (
			<UserProvider>
				<UserContext.Consumer>
					{user => <Router {...user} />}
				</UserContext.Consumer>

			</UserProvider>)
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx